<div class="main-black border-radius-bottom white-box">
	<div class="m-0 p-4">
		<app-attachments *ngIf="siteId"
			[title]="'attachments.site' | translate"
			[source]="source"
			[sourceId]="siteId"
		></app-attachments>
	</div>
</div>
